import Crud from '../views/Role/Crud'
import Entity from '../views/Role/Add'

let routes = {
    path: '/roles',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/roles/add',
            name: 'NewRole',
            component: Entity,
            meta: {
                ability: 'papeis.gerenciar',
                pageTitle: 'Papéis',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/roles',
                    },
                    {
                        text: 'Novo Papel',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles/edit/:id?',
            name: 'EditRole',
            component: Entity,
            meta: {
                ability: 'papeis.ver',
                pageTitle: 'Papéis',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/roles',
                    },
                    {
                        text: 'Editar Papel',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles',
            name: 'list-roles',
            component: Crud,
            meta: {
                ability: 'papeis.ver',
                pageTitle: 'Papéis',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
